import React from 'react';

const Map = () => {
  return (
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.632624696453!2d-2.5892165847928603!3d51.50160881894838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487191ee1aa7e713%3A0xf0548cab06b303c6!2s50+Kenmore+Cres%2C+Bristol+BS7+0TR%2C+UK!5e0!3m2!1sen!2sus!4v1526586300943"
        width="430"
        height="400"
        style={{border: 0}}
        frameBorder="0"
        allowFullScreen />
  );
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js